import { render, staticRenderFns } from "./MarksListTopicHeaderPopover.vue?vue&type=template&id=40f538d6"
import script from "./MarksListTopicHeaderPopover.vue?vue&type=script&lang=js"
export * from "./MarksListTopicHeaderPopover.vue?vue&type=script&lang=js"
import style0 from "./MarksListTopicHeaderPopover.vue?vue&type=style&index=0&id=40f538d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports